module.exports = __webpack_public_path__ + "img/phone-alt-solid.bacc2d0a.svg";